import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const createDeliveryChallan = createAsyncThunk(
    "/prosafe/create-delivery-challan",
    async (payload) => {
        try {
            const myurl = `${V_URL}/prosafe/create-delivery-challan`;

            const response = await axios({
                method: "post",
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                },
            });

            const data = response.data;

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const createDeliveryChallanSlice = createSlice({
    name: "createDeliveryChallan",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createDeliveryChallan.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createDeliveryChallan.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(createDeliveryChallan.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default createDeliveryChallanSlice.reducer; 
